export enum FiltersFormPersonSearchMessage {}

export const FILTERS_FORM_PERSON_SEARCH_DEBOUNCE_TIME = 300;
